module.exports = __webpack_public_path__ + "static/img/selected_zixun.a42f346a.png";